export { BatteryChargeIcon } from './battery-charge'
